export const ACCOUNTS_CONTAINER_TAG_NAME = 'accounts-container';
